import React, { PureComponent } from 'react';
import { prefersMiles } from 'functions/distanceUnits';

class LocationComponent extends PureComponent {

	render() {
		const { showDistance, location, otherLocation } = this.props;
		if(!location) {
			return null;
		}
		// If a user is serialized incorrectly they may receive an incomplete location object and cause errors rendering this component
		const text = location.relativeLocation();
		const viewerLocation = otherLocation ? otherLocation : myUser.location;
		const distanceFromLocation = location.getDistanceFromLocation(viewerLocation);
		const distanceSeverity = distanceFromLocation ? distanceFromLocation.getDistanceSeverity() : 0;

		const distanceText = showDistance && distanceFromLocation
			? distanceFromLocation.approximateLabel(prefersMiles(viewerLocation))
			: null;
		// A location guessed from an IP address has no place to name.
		if(!distanceText && !text) {
			return null;
		}

		return (
			<span
				title={text}
				className={`location distance_severity distance_severity_${distanceSeverity}`}
			>
				{[text, distanceText].filter(Boolean).join(' · ')}
			</span>
		);
	}
}

export { LocationComponent };
